import React from 'react';
import logo from 'assets/osamLogo.png';

const OsamLogo = () => {
  return <img className="OsamLogo" src={logo} alt="osam-logo" />;
};

export default OsamLogo;
